import { GenericAbortSignal } from 'axios';

import { Paginated } from 'models/Paginated';
import { StediPayer } from 'models/StediPayer';
import http from 'services/http';

export const stediPayerQueryKeys = {
  base: ['stediPayers'],
  index: (params: Record<string, any>) => ['stediPayers', params],
};

export async function indexStediPayers(
  params: {
    search?: string;
    sortBy?: string;
    page?: number;
    pageSize?: number;
    assignable?: boolean;
    assignableTo?: string;
  },
  signal?: GenericAbortSignal
) {
  return http.get<Paginated<StediPayer>>('/stedi_payers', { params, signal }).then((response) => response.data);
}
